<template>
    <div
        class="collapse collapse-arrow rounded md:rounded-md mb-2.5 md:mb-8"
        :class="{'collapse-open': isOpen,'collapse-close': !isOpen}"
    >
        <div
            class="collapse-title text-base xs:text-lg text-white font-bold gradient-primary min-h-[2.5rem] flex items-center pl-3 md:pl-5 pb-0.5 pt-1.5 md:min-h-[3.125rem] relative cursor-pointer rounded-b md:rounded-b-none"
            @click="toggleCollapse"
        >
            {{ $route.meta.pageTitle }}
        </div>
        <div class="collapse-content bg-white p-0">
            <div class="px-0 pt-2.5 pb-5 md:pt-5 md:pb-7 md:px-5 lg:px-8">
                <slot name="content" />
                <div class="text-right mt-4">
                    <button
                        v-if="isShowEditButton"
                        class="btn-text text-primary border-b border-primary text-[1rem] xs:text-[1.125rem]"
                        @click="goBackService()"
                    >
                        返回修改
                    </button>
                    <span
                        v-if="isShowRemoveButton"
                        class="mx-2.5 text-gray-400"
                    >/</span>
                    <button
                        v-if="isShowRemoveButton"
                        class="btn-text text-primary border-b border-primary text-[1rem] xs:text-[1.125rem] disabled:text-gray-400 disabled:border-gray-400"
                        @click="removeService()"
                    >
                        刪除變更
                    </button>
                </div>
            </div>

            <slot name="footer">
                <div
                    v-if="footerButton"
                    class="flex justify-center space-x-6 my-6"
                >
                    <button
                        class="btn btn-ghost border border-gray-400 rounded-full mb-3 "
                        @click="cancelApply"
                    >
                        取消申請
                    </button>
                    <button
                        class="btn rounded-full mb-3 sm:px-6 gradient-primary"
                        @click="submitData"
                    >
                        確定
                    </button>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
import { ref, inject } from 'vue';
import { useStore } from 'vuex';
import { EUDC } from '@/utils/EUDC';
import dialogContnet from '@/json/dialogContent.js';
import { isAplCatlA3A4A5 } from '@/utils/is/aplCatlUtils.js';

export default {
    name: 'CollapseConfirmData',
    props: {
        codeId: {
            type: String,
            required: true
        },
        isShowEditButton: {
            type: Boolean,
            default: true,
        },
        isShowRemoveButton: {
            type: Boolean,
            default: false,
        },
        needEUDC: {
            type: Boolean,
            default: true,
        },
        footerButton: {
            type: Boolean,
            default: true,
        }
    },
    emits: ['removeService', 'checkSubmit', 'goBackService'],
    setup(props, { emit }) {
        // const router = useRouter();
        const store = useStore();
        const $vfm = inject('$vfm');
        const isOpen = ref(true);
        const visiblePopup = ref(false);
        EUDC(props.needEUDC);
        const toggleCollapse = () => {
            isOpen.value = !isOpen.value;
        };
        // 取消申請回官網
        const cancelApply = () => {
            if (isAplCatlA3A4A5()) {
                const params = dialogContnet.leaveA3A4A5;
                $vfm.show({
                    component: 'DialogBase',
                    params,
                    on: {
                        confirm() {
                            store.dispatch('permissions/goFubonOfficial');
                        },
                        cancel() {
                            $vfm.hide('DialogBase');
                        }
                    },
                });
            } else {
                store.dispatch('permissions/goFubonOfficial');
            }
        };

        const submitData = () => {
            emit('checkSubmit');
        };

        // 返回修改 保單變更才打api
        const goBackService = async () => {
            emit('goBackService');
        };
        // 刪除變更
        const removeService = () => {
            emit('removeService');
        };

        return {
            isOpen,
            toggleCollapse,
            cancelApply,
            removeService,
            goBackService,
            submitData,
            visiblePopup,
        };
    }
};
</script>

<style scoped lang="scss">
.collapse-arrow .collapse-title:after {
    @apply w-[0.875rem] h-[0.875rem];
}
.collapse.collapse-open {
    overflow: hidden;
}
.collapse.collapse-open .collapse-content {
    overflow: hidden;
}
</style>
